import { useFeature } from '@growthbook/growthbook-react';
import { PROVIDER_BUYFLOW_FLAGS } from 'config/sharedFunctions';

export function useProviderBuyflowFlags(): Set<string> {
  const xfinityOn = useFeature(PROVIDER_BUYFLOW_FLAGS.xfinity).on;
  const coxOn = useFeature(PROVIDER_BUYFLOW_FLAGS.cox).on;
  const attOn = useFeature(PROVIDER_BUYFLOW_FLAGS.att).on;
  const starlinkOn = useFeature(PROVIDER_BUYFLOW_FLAGS.starlink).on;

  const enabled = new Set<string>();
  if (xfinityOn) enabled.add('xfinity');
  if (coxOn) enabled.add('cox');
  if (attOn) enabled.add('att');
  if (starlinkOn) enabled.add('starlink');
  return enabled;
}
